
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoPl42nRm4a6zVEamzB0MuAQouhS7pT0dClven5d4uQ5YMeta } from "/var/www/2025-04-24_15_40/pages/edo.vue?macro=true";
import { default as helpj5_45wxq4MpdSg1ZA2Ghg2uyi7iRBpzlLb6lDCVU_45oKlIMeta } from "/var/www/2025-04-24_15_40/pages/help.vue?macro=true";
import { default as cargoDWPn_O8705zX61AOK2VSWUJShg0n1xEjCC3NNbbygmkMeta } from "/var/www/2025-04-24_15_40/pages/cargo.vue?macro=true";
import { default as chinaqZdZIn5rJ5oGIodde_45c8kwj1iaQiQG0gyMp_45mPxq67MMeta } from "/var/www/2025-04-24_15_40/pages/china.vue?macro=true";
import { default as index_0eWd8oO8ASDDKppyg_h9OjDmc_CmrOkOMur9dh4ty4Meta } from "/var/www/2025-04-24_15_40/pages/index.vue?macro=true";
import { default as _91slug_93eKwV1lf0DoQUy7fyddEvPd1xbuS2T1rDT5D3s_UEB3kMeta } from "/var/www/2025-04-24_15_40/pages/[slug].vue?macro=true";
import { default as belarusrj11pIm3LNqze4SPESxlqEkIYpv4ahJaum_tFDJzRRQMeta } from "/var/www/2025-04-24_15_40/pages/belarus.vue?macro=true";
import { default as bonusesPoVL8EJWEtKRbrS_3n_45eNEoPn0pmBGsFVSv_45rGKsbZkMeta } from "/var/www/2025-04-24_15_40/pages/bonuses.vue?macro=true";
import { default as apiu_dmIEK5PJGUo6fvt_2RaTihuWGhrUQGlmS3r8dGmJUMeta } from "/var/www/2025-04-24_15_40/pages/dev/api.vue?macro=true";
import { default as cms7FnyyyIHMrb8Ios9tCddKuGBVi0U2DJmq0oCf10hSn8Meta } from "/var/www/2025-04-24_15_40/pages/dev/cms.vue?macro=true";
import { default as konkursnj8VMUoP3WM4xkQOSiaeIi6T_458ck8M4Ux_8jPaYc3ZsMeta } from "/var/www/2025-04-24_15_40/pages/konkurs.vue?macro=true";
import { default as successxGQCyHqGpy7cSVrbdQ_83Hw8wjS7o1CW_ltAg4FjwnsMeta } from "/var/www/2025-04-24_15_40/pages/success.vue?macro=true";
import { default as tariffshW7FVTZadljcjH__450nVFgsrtZcvB6urYTV0liEzm8OoMeta } from "/var/www/2025-04-24_15_40/pages/tariffs.vue?macro=true";
import { default as vacancyFD10ulHNkKO1QfBdFHvj4xNUvvMk_455pVSAt3zDj3x8gMeta } from "/var/www/2025-04-24_15_40/pages/vacancy.vue?macro=true";
import { default as contactsIHZs51kf46zX6RD9ZkNEZAR_452Xkn5lXmYd7iptANk2MMeta } from "/var/www/2025-04-24_15_40/pages/contacts.vue?macro=true";
import { default as giveaway_45mLkXn_45mb4y6zYlk_454v1XYmjsIykUlVPptVvgqAVRzsMeta } from "/var/www/2025-04-24_15_40/pages/giveaway.vue?macro=true";
import { default as guide_45lk_pUISOaVZ0ip6LwLntZ_45a3CMjuYbLPzxQzbXZZucUgwMeta } from "/var/www/2025-04-24_15_40/pages/guide-lk.vue?macro=true";
import { default as servicesi8IWOKtLuQ9RdunH2R_OHzWbzCTRNN_45ePohpcHbzFdcMeta } from "/var/www/2025-04-24_15_40/pages/services.vue?macro=true";
import { default as telegramsTS_45kh3pDodamg42BrtrklKq3EL_45A7x9W5nIbVyF_cUMeta } from "/var/www/2025-04-24_15_40/pages/telegram.vue?macro=true";
import { default as documentssN_45vS1k6w_45Q3s_45UBoRITSjYdp89MV6T6lgY89IPbPesMeta } from "/var/www/2025-04-24_15_40/pages/documents.vue?macro=true";
import { default as franchiserHoVqs6H8xFa2UOhoJgKaM3gaJWreYrLXhxxtbPXCPcMeta } from "/var/www/2025-04-24_15_40/pages/franchise.vue?macro=true";
import { default as insuranceA_SwoEbnutBfm0Xiyea_453tS1cO_45dhkL6H8mt2lM4Vt4Meta } from "/var/www/2025-04-24_15_40/pages/insurance.vue?macro=true";
import { default as kirghiziaeQPx5zy4tL8vKlpFHdAQcRo5LZUaK4ob_45Zo2wQOBs60Meta } from "/var/www/2025-04-24_15_40/pages/kirghizia.vue?macro=true";
import { default as mapSchemeFMysVHZAx6GJtk9V_45VtxeYCG7a5WeIQ5_TOJLtmxKLYMeta } from "/var/www/2025-04-24_15_40/pages/mapScheme.vue?macro=true";
import { default as _91id_93gGzqXfqijWSnbCyVoixx6Cj_9d6Qk857VX2ShAPYA8EMeta } from "/var/www/2025-04-24_15_40/pages/news/[id].vue?macro=true";
import { default as return_45sdtUzePZYiXn_z_45kBR92a71tbICsLQhU0O0QVaGiS02B0Meta } from "/var/www/2025-04-24_15_40/pages/return-sd.vue?macro=true";
import { default as smsClient1k3ww0W6YcVlQLyUhOesHXyZ_HEFziE8cFDGXgHcbTMMeta } from "/var/www/2025-04-24_15_40/pages/smsClient.vue?macro=true";
import { default as terminalsfuar_ZNd5f0sCtfC0BII5Br1_45Ho596RJwvOMGnDNScAMeta } from "/var/www/2025-04-24_15_40/pages/terminals.vue?macro=true";
import { default as iframeCyTPLQkciFVI1N_v8iE7dwIhHSyYNmR__45So3NjkaJnIMeta } from "/var/www/2025-04-24_15_40/pages/dev/iframe.vue?macro=true";
import { default as directionslNfk7YXG_5go_45a6aisB_45DD7nW8VJhnqnMLlqLc70y3gMeta } from "/var/www/2025-04-24_15_40/pages/directions.vue?macro=true";
import { default as kazakhstanMaX28GKx_45tJMI_y03wD9ctXHT88rQMEZEIph_45_45_hiUkMeta } from "/var/www/2025-04-24_15_40/pages/kazakhstan.vue?macro=true";
import { default as indexlxhJGoMDT8f6Ubtl0ndorbVzwAkQZKiM2qfKIjfn8wEMeta } from "/var/www/2025-04-24_15_40/pages/news/index.vue?macro=true";
import { default as svgpou0y_DqJ7SCUMNuVIm9zwx2c_45E9X6bnYtvYYIEN_45k8Meta } from "/var/www/2025-04-24_15_40/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failTvUN0IyZGT91SuGo2_45l_45ZfM5lh_Lu_45GKhcpzloaJ5T8Meta } from "/var/www/2025-04-24_15_40/pages/vzpay-fail.vue?macro=true";
import { default as constructorCzHPTavfccPUqFLi49LrZ_45KdXNNGTzu_H8QQRI_45ZbGUMeta } from "/var/www/2025-04-24_15_40/pages/constructor.vue?macro=true";
import { default as indexqtNLoX9_w5EMlDZelB29zL4oACQBfMQiDfrIY2bqlWYMeta } from "/var/www/2025-04-24_15_40/pages/gifts/index.vue?macro=true";
import { default as informationXlfMB8v2KXjTGSIuKza8ro1VnGlS0LNq_45gRFicAhQSsMeta } from "/var/www/2025-04-24_15_40/pages/information.vue?macro=true";
import { default as lightpQe_45WfmlJZf4jEHGJ_plZ_1c3JV8uCWiRuN705BG0dAMeta } from "/var/www/2025-04-24_15_40/pages/order/light.vue?macro=true";
import { default as claim_45filingf8GFi1PSGPgWVFWsbo81d_45D_6TXnUtz8KCsG_EP7Ng8Meta } from "/var/www/2025-04-24_15_40/pages/claim-filing.vue?macro=true";
import { default as _91type_93AwKeGFhvxQlWGPgyfcRArhobil_45LMniuHp3xQoG71VMMeta } from "/var/www/2025-04-24_15_40/pages/gifts/[type].vue?macro=true";
import { default as marketplacesTzsS4UVMlDQD1b1IrxjmzGWGBb2zkknixHsjBbANHmcMeta } from "/var/www/2025-04-24_15_40/pages/marketplaces.vue?macro=true";
import { default as networkshopsY_l9PZ79a8qmfTL2poGeXqTyAdLEgGXYUgTUPofofBEMeta } from "/var/www/2025-04-24_15_40/pages/networkshops.vue?macro=true";
import { default as online_45storeXB7Ej_45YrdHb2SvtcV0TSdGH2wV9_45DBzjyDsDS0DNOXgMeta } from "/var/www/2025-04-24_15_40/pages/online-store.vue?macro=true";
import { default as manageLUr7K5_nmJ63LysybS3g_45m7GvDtqbn7oRW8E4q9xScMMeta } from "/var/www/2025-04-24_15_40/pages/order/manage.vue?macro=true";
import { default as registration18vQd1A1i0V_3hjEGUmOjJpcuqbo_45DsxekBkqoAtWjkMeta } from "/var/www/2025-04-24_15_40/pages/registration.vue?macro=true";
import { default as run_45scheduleSMJ1VsyK6FvvAOuf48l_XTQ5JcLhqPFateDDTnGDE6sMeta } from "/var/www/2025-04-24_15_40/pages/run-schedule.vue?macro=true";
import { default as safe_45custodyPH8_45qcYgZnB9Tr8bbrtywoQkQztzjK4pZ3Ckjz_gndMMeta } from "/var/www/2025-04-24_15_40/pages/safe-custody.vue?macro=true";
import { default as imageIKRPR6rml6aXftjD5YOm5Kob3t5tdyH5_vBhaBnzHLoMeta } from "/var/www/2025-04-24_15_40/pages/ui-kit/image.vue?macro=true";
import { default as indexqEAIbSt7uWXZ35RMoKbZCRdB7SEsIJCOln5JPp1t_sMMeta } from "/var/www/2025-04-24_15_40/pages/ui-kit/index.vue?macro=true";
import { default as bagOwThS2_J_5PsY8g4WD8kZKb42nZZZneUN3G22sCKr_45UMeta } from "/var/www/2025-04-24_15_40/pages/wrapping/bag.vue?macro=true";
import { default as boxC3fj7abFNOPyHwdzwVxmDuwE9C_45_mwb_45c4ufDVdXFB0Meta } from "/var/www/2025-04-24_15_40/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingUSeOjima196tZXoL1_45i45h6dvpEkP2137wiVdnzSqYQMeta } from "/var/www/2025-04-24_15_40/pages/cargo-loading.vue?macro=true";
import { default as happybirthday4Kt5On9Q8wCIrSjUaHXbGM3_gdHdjNuDz7ZNKX3ApFYMeta } from "/var/www/2025-04-24_15_40/pages/happybirthday.vue?macro=true";
import { default as manage5_qHrYyzBRKAl8fGmneNJD_45OMYrgu4__45223xx6sSW64Meta } from "/var/www/2025-04-24_15_40/pages/iframe/manage.vue?macro=true";
import { default as auth396aIiJLRCP0q1Hyb4Xhz73RF9ta5i25QudmByBm7doMeta } from "/var/www/2025-04-24_15_40/pages/personal/auth.vue?macro=true";
import { default as publicZZOMJiRWFzvdzHOiDijq_P2CbSJFR91I7VlFNvPxn7EMeta } from "/var/www/2025-04-24_15_40/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerEc_45elTaaUypW0DVey4aPM64k8cquuCNkoPcBJEE5jBMMeta } from "/var/www/2025-04-24_15_40/pages/already-answer.vue?macro=true";
import { default as tariffssFmPPN3ZQovTNPGBEIWyrkVInP9fvLFdK15d9b2ofy4Meta } from "/var/www/2025-04-24_15_40/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93PM_dimFe4LeIJN5Ch2dMbPp_XuhhEYhx3_pUgHG9ZYcMeta } from "/var/www/2025-04-24_15_40/pages/order/pay/[id].vue?macro=true";
import { default as indexEssbAYOBuvB82rAl0vc_45bHF01OHS24VQK71jzr5KZ2wMeta } from "/var/www/2025-04-24_15_40/pages/personal/index.vue?macro=true";
import { default as privacy_45policygWBrcW356SqxW2AfA7bdg2o7aQLq5xbesyYNR6MQdvkMeta } from "/var/www/2025-04-24_15_40/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93qylWRAn3vTisXA0LSG9X5GhxsKzo4vgFBfZg_45zlCrSQMeta } from "/var/www/2025-04-24_15_40/pages/welcome/[hash].vue?macro=true";
import { default as indexy3IVCt4Dp3wmQ0yh8NDaw01y_45FsNgzNz_45Zgs6nS0u54Meta } from "/var/www/2025-04-24_15_40/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiahQKIRAdKqyo_BzYWn0Mtp14ST30YDpO3T9vUm0DUjEAMeta } from "/var/www/2025-04-24_15_40/pages/delivery-russia.vue?macro=true";
import { default as payment_45methods8DtfE1PuoTbge8Zt3nWQHuPkh3YRmkXM8kfjlqM0RQcMeta } from "/var/www/2025-04-24_15_40/pages/payment-methods.vue?macro=true";
import { default as qr_45infojl9vNDjvjxW_453L_45PRl3_DycQn4CUQ2loh7WUSNxRO08Meta } from "/var/www/2025-04-24_15_40/pages/payment/qr-info.vue?macro=true";
import { default as successbHeMXYT1dufJ6ZZWyMOuZdgSgT_45rpw74GyiNEfxloYUMeta } from "/var/www/2025-04-24_15_40/pages/payment/success.vue?macro=true";
import { default as importecnImX2BLFxAAQY3Y1F5pB5HzLQrcStrYBfS9kPvD_UMeta } from "/var/www/2025-04-24_15_40/pages/personal/import.vue?macro=true";
import { default as logoutSqOz31pw3SRBEDCGzTn7Sr80ceN9l5GH_45SqKtSjtKYQMeta } from "/var/www/2025-04-24_15_40/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryZjBftPICXLCROtTX6y0xcizhG9Z_45z9MJFxiOG1a7cR8Meta } from "/var/www/2025-04-24_15_40/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryECLzHRFqRdJuidjYII1hkyYawXO1_5oHlv0lptimiyEMeta } from "/var/www/2025-04-24_15_40/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024_45FR3O7p8HTkbotxzCy4wv61V_45IjlHOijJD3tmsR5YJEMeta } from "/var/www/2025-04-24_15_40/pages/happynewyear2024.vue?macro=true";
import { default as ozonbc_45kzl1BBaXXSMnj5qgPhpXlyFAm7p3SfR6L9RzRCIIMeta } from "/var/www/2025-04-24_15_40/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45failEzjhalCSokclM3S3QdRgLmUx8MthjEy9qg_sK4ebUd8Meta } from "/var/www/2025-04-24_15_40/pages/payment/pay-fail.vue?macro=true";
import { default as accountCJGQMH_45QF_45AZhzB0D1qQRkDswfLg6_452i_K_zUR_45Vbv8Meta } from "/var/www/2025-04-24_15_40/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsgpJZ0P4bgG5Goj_0wSh6qWUM_456wllwxiqbzkyARZUAIMeta } from "/var/www/2025-04-24_15_40/pages/prohibited-goods.vue?macro=true";
import { default as directioni0EF7q0qkY7t8yn5BfyIH7j_459KgH9KfMgZfBgoJtdggMeta } from "/var/www/2025-04-24_15_40/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupsUyWhE5DRS_n3RRfXvEjOhlM0cKXcJkbcDMt7Rk65csMeta } from "/var/www/2025-04-24_15_40/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoxzHl2aVGjGb_45WlhMkHajirykMZPEpaxDhq_45rNroDB6MMeta } from "/var/www/2025-04-24_15_40/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorBu0piRNMzGEBRX6hjZpmm8vEsrIZK_EDs8oFMXnbYBkMeta } from "/var/www/2025-04-24_15_40/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesgd_a6U5kb6cphVYxDzYtiQBygX5Vd0EOMq60oN5UotcMeta } from "/var/www/2025-04-24_15_40/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93PBnCqH3KenYCYH_45GZt9n5qmGbEh7xUZD5LI4PHm0nDIMeta } from "/var/www/2025-04-24_15_40/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoTSVM9oiQIddg5JXoNtF8_45jKL9PeZNZkUKBAnpbP8LycMeta } from "/var/www/2025-04-24_15_40/pages/payment/card-info.vue?macro=true";
import { default as discountlmSe9kGJ9RTFnwR6YhyA37Sbhf1EcCykJZfHl8pkAwcMeta } from "/var/www/2025-04-24_15_40/pages/personal/discount.vue?macro=true";
import { default as hard_45boxMPwqy_45jbj1bP1EG9ROe8mjvJGbEKRTWMiwWaL3AEvJQMeta } from "/var/www/2025-04-24_15_40/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptJtJELVsOUg2vdPBI4omA1nr4apcoik3tDXbjdFZwnjMMeta } from "/var/www/2025-04-24_15_40/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917fcFJ59xodtMSZLJOvqWwXPoMvNdBY1GdlX07i54ZyRsMeta } from "/var/www/2025-04-24_15_40/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationT4yaV_45EivE_z95ja6kmq31WhnyJVU0ZW0vGHaB73Ax0Meta } from "/var/www/2025-04-24_15_40/pages/mobile-application.vue?macro=true";
import { default as indexrtb8dg34gWzENfB5Frq3RWE8cDyUJ9kHTI5nWCUxprQMeta } from "/var/www/2025-04-24_15_40/pages/order/create/index.vue?macro=true";
import { default as boat6Z45tzYwBV7Ukwy76Xdnmu4iULSPgk4zpkTSUvMo3C8Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/boat.vue?macro=true";
import { default as sofajUbWA1GK0lzjwXyZsLgfBLmbd0Yc_45Fx_0aJW5ai8WBsMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardT3tg5g8HNSIC_45bcenOJsDKZ4UDRQg_45cXzeJBo5vQ7bcMeta } from "/var/www/2025-04-24_15_40/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesO_lB5jqrmGnEShex2e11fi8zU4UEmukw9VC6b3XPWccMeta } from "/var/www/2025-04-24_15_40/pages/personal/promocodes.vue?macro=true";
import { default as benchkiUEFhoRaEBr6_RB6gTMzxu30ZrvLdItCmVBZuhGTbwMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/bench.vue?macro=true";
import { default as booksuDMgMBlpqZGAKm3ltERB9CaR0JDxK1SV2HNsn7ZK_I8Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/books.vue?macro=true";
import { default as cableaMbm0YqzR9hUHqZy2U0TUtFxG8ImUzCtPRQ0l4NPQuIMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/cable.vue?macro=true";
import { default as chairAnEkoj_puIVuaSOYODwyY6EQdw2dFGWsMJczqvvnzjkMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsVDPLRFVr5vuNz2pBXugEWQYgiXQJUo8YbkqqUUFQ4ScMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/goods.vue?macro=true";
import { default as index_456vv_VF4vJhXeE6wzLBUg8tGATR9qANkBa0NXeTHZ0cMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/index.vue?macro=true";
import { default as metalIOiXleDZGtV59cFvp25UOO4aITZs55eODoGEv5F_hWEMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/metal.vue?macro=true";
import { default as pianopZ_457llYEHKK_45DH_45nXmRB_USY2ukZIR92LBuIim7ouBoMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesvN0VW_wz3_45Prf2qgQS9_Pve6YcRfpS7Z_R3bblg_45YT0Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolslOmlNhCDp_OTA7QFg1gKlmQyoaIFD4lVJG35AjLGS0cMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxawPfXgRrETNZ20cIMyYQ_IXxl92ay7PauPIgQ9RkugIMeta } from "/var/www/2025-04-24_15_40/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93SamMVL8jIJtBBLXnEzr91_Az6Brw_4544ZqpJoq8x2Ad4Meta } from "/var/www/2025-04-24_15_40/pages/personal/bonus/[tab].vue?macro=true";
import { default as print0RMEb2R7wVZ2Cpe3eYbn6Ba0ZlK0fsURmUjXPolGHKMMeta } from "/var/www/2025-04-24_15_40/pages/personal/order/print.vue?macro=true";
import { default as dishes2C_45k9XN0LLidVDvY2cEzvUFE_5AZGheDHEksUgC8v68Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/dishes.vue?macro=true";
import { default as engineOddqDvgMsVIfXm89RU4wdIs67pw8I_czp0ZvbkgSg2kMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/engine.vue?macro=true";
import { default as lumberNm2shinOaVBTSXsWyJLYoQpGmr9PXVHX95boX6NT4G0Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsRXDA8LKDkE5eZ8SsdVGttWmhE4dQ6l05cb7BsuuW1uwMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmZ_qd5NI0CFGLgOgOK0SGNxCNtVhKl11b_45CwtyGknvd4Meta } from "/var/www/2025-04-24_15_40/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingdWEVAEG9x8IHudYpNGoyBBY74nFez1cbgylTpDvDwwoMeta } from "/var/www/2025-04-24_15_40/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalOHUeYtpi0PZYwkh9bdb_45tY7gkQe8Kws2TsaHDECh0_45oMeta } from "/var/www/2025-04-24_15_40/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_935NDC8MliMvsLQWxHxDNhn9Q_WECXnMSuKU48o7P6fUgMeta } from "/var/www/2025-04-24_15_40/pages/personal/order/[guid].vue?macro=true";
import { default as create_8HGUeDERXFl8UV2vGi2Ir9LG0T9DRNm_45w79_ayNsNMMeta } from "/var/www/2025-04-24_15_40/pages/personal/order/create.vue?macro=true";
import { default as barrelsRt_45gnX4PkLceiv7uoq5_45RoiX_vfotae_wIbRZx36_4504Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesQpZovWte6iHnmmQ5XFyM9XBNqE2sof79IYP5GVmay1kMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragilef4BCwzdpPATyrFCmQaA6v4ziTHXoVNWwpag9J_i1bpEMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailer1PIDKvgd1tcxChfNWNMvR77c2B4Ii03HXa9z6rZT1tAMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45package9qTmGJIdh8K3gSnIj6DRSb0yT2x0kPJGlMG98Mw_45JgIMeta } from "/var/www/2025-04-24_15_40/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successe_45_45d82UiT1WEJaKTYIY_d730tiQcVsXMETEMQWbUgVAMeta } from "/var/www/2025-04-24_15_40/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45package8Y3Myhq0_FE5VzgJ1OgTI9xEdgyNmgarTLU0N_3FhncMeta } from "/var/www/2025-04-24_15_40/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesHt9wRP05k__zZL3maFyVcRtM1t44ySh5KyhaaHxyXfoMeta } from "/var/www/2025-04-24_15_40/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93J6vZeIVHWlwYWTgP_453nfhT_THkBE51tIUR7bVGFQdEMMeta } from "/var/www/2025-04-24_15_40/pages/order/administer/[guid].vue?macro=true";
import { default as furniturekriTI4JqJUpFA7vgmR_ZxfZ4HPJ_45DBE1HbnW9AOZejkMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizeduXrVvds0O_45eXCk7jGMGAkMYYTp8vixnLNyTzB2SN_45_45YMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeydd3ExCgzXRX1kfQgObD6l_45ZZl34lNXmc3M9ozxWz70Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93tBfeVGjMud4_wQhGphR0RG_9Y9xDgR5rxUmAykDePIYMeta } from "/var/www/2025-04-24_15_40/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93_45KToGYj2jEs3spwq95ftuv7XN94uHf20xiwhynElQkcMeta } from "/var/www/2025-04-24_15_40/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsjWtanWu0_45m139odmgA0Q2oZNrAaHI0eiiHKnaHE5P58Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapers55nbI0l4Rg9rtCuKiSq4DnzHA1gBoZkQiTVtrZCZHI0Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargokag2kwOdLe8qUmecNQ16odkthM04vSGMS46j9R_45wdaoMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobile2XWRAKlfQSCi6_FCFrkf4StgkXqSGgDqxbpZyFhyHdkMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexW1lly7Y2ZcamWnfGThBE0M7IGybvSCs76Gipz6iQBJsMeta } from "/var/www/2025-04-24_15_40/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45market8LMuIMWbk3btUqbXh_55RD18ACo6zVPrw2WCCNHaVWoMeta } from "/var/www/2025-04-24_15_40/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatessdq0uTcintUX_45sJOopL5nMxDfhTuTnlNulLW0nqR3JYMeta } from "/var/www/2025-04-24_15_40/pages/personal/orders/templates.vue?macro=true";
import { default as indexb_c1AZYexoubRX4RYdiVgawQZkMmfbIVmuTKVhY_45r_0Meta } from "/var/www/2025-04-24_15_40/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorUXQ7vK_454q3HpAY4rvYpvLc88ejVhQZnRtPCp2KZQXO4Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93i_45ZGUgq7rqIUyINNW1Y4CnRDb7c3Z9Gtjgeo0vu34rsMeta } from "/var/www/2025-04-24_15_40/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexpSvk2z9mev3YmGV4cMKAFTaekJ10fXU7kvWRtUVhEvwMeta } from "/var/www/2025-04-24_15_40/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93G5B1biRi3wq20S2ftz44RXw2t_m_45cB4nuadr0xSMR1AMeta } from "/var/www/2025-04-24_15_40/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsD95_45_5cZbEtyUUFikPJvNM__KCDMMmN_453qMkCQTXNHYMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexkfaIStm9yhRfRTUZXu5EoPkCrqT4OFtTzlbnNIWOOzoMeta } from "/var/www/2025-04-24_15_40/pages/personal/group-printing/index.vue?macro=true";
import { default as indexroHG1rtCzLeDyu0QIKZRNfkPvmTJXRVXJn4pgMeF1LYMeta } from "/var/www/2025-04-24_15_40/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devices1t2Tx2_LelZQWIn00XoxZoi3Pon7U5GUngZZ4_45g2euoMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93Cb6elC98E0lwbQnU5p9eOIU5gNR0uLQi3jB_iwD9fgAMeta } from "/var/www/2025-04-24_15_40/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93Nlwryri53sIzVplHbrooxf1MICMG8BsxKYC2MxJLGFUMeta } from "/var/www/2025-04-24_15_40/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93ZOpDZS0s8We_45PZvyLMUaZ0WjwBrAe4KqfD2IdQGy7JAMeta } from "/var/www/2025-04-24_15_40/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentsVS7doTTViSMpnBGB9Hi3IfHEj2i_45QgZ2NX5kgmn2nEMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsOYhYmJGR_Q2hXLw0GXidahqN2niy_un_45tRHaqJ_oZF4Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsMfZw7a5GBLFdFS2bLJ8lrq2SZU9Upy5qNy5gNu_45rB4kMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentpNDg6_45x2oLl1gZ3K_45aCD9_IqYdDH7CE9_45b0m3wu6lX4Meta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportation2saVXfVfPVGjb5pG7rOopBN8ibYYBR_45_upJn5Yr3_MoMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93Kcq1MmeAJPw_oHMzL4NVIb4l36_ZCmnjJixcDDib95UMeta } from "/var/www/2025-04-24_15_40/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationTSicmrPQAKvrpem_45PzXROj9MIydOix__vIyaxjyDZFcMeta } from "/var/www/2025-04-24_15_40/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-04-24_15_40/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-04-24_15_40/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-04-24_15_40/pages/cargo.vue")
  },
  {
    name: "china",
    path: "/china",
    component: () => import("/var/www/2025-04-24_15_40/pages/china.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-04-24_15_40/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93eKwV1lf0DoQUy7fyddEvPd1xbuS2T1rDT5D3s_UEB3kMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/[slug].vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-04-24_15_40/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-04-24_15_40/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-04-24_15_40/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-04-24_15_40/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursnj8VMUoP3WM4xkQOSiaeIi6T_458ck8M4Ux_8jPaYc3ZsMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-04-24_15_40/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-04-24_15_40/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-04-24_15_40/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsIHZs51kf46zX6RD9ZkNEZAR_452Xkn5lXmYd7iptANk2MMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-04-24_15_40/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-04-24_15_40/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-04-24_15_40/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-04-24_15_40/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-04-24_15_40/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-04-24_15_40/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-04-24_15_40/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-04-24_15_40/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeFMysVHZAx6GJtk9V_45VtxeYCG7a5WeIQ5_TOJLtmxKLYMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93gGzqXfqijWSnbCyVoixx6Cj_9d6Qk857VX2ShAPYA8EMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-04-24_15_40/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-04-24_15_40/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-04-24_15_40/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-04-24_15_40/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-04-24_15_40/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-04-24_15_40/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexlxhJGoMDT8f6Ubtl0ndorbVzwAkQZKiM2qfKIjfn8wEMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-04-24_15_40/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-04-24_15_40/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorCzHPTavfccPUqFLi49LrZ_45KdXNNGTzu_H8QQRI_45ZbGUMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexqtNLoX9_w5EMlDZelB29zL4oACQBfMQiDfrIY2bqlWYMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-04-24_15_40/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-04-24_15_40/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-04-24_15_40/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93AwKeGFhvxQlWGPgyfcRArhobil_45LMniuHp3xQoG71VMMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-04-24_15_40/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-04-24_15_40/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-04-24_15_40/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-04-24_15_40/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-04-24_15_40/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-04-24_15_40/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-04-24_15_40/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-04-24_15_40/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-04-24_15_40/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-04-24_15_40/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthday4Kt5On9Q8wCIrSjUaHXbGM3_gdHdjNuDz7ZNKX3ApFYMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manage5_qHrYyzBRKAl8fGmneNJD_45OMYrgu4__45223xx6sSW64Meta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-04-24_15_40/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-04-24_15_40/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffssFmPPN3ZQovTNPGBEIWyrkVInP9fvLFdK15d9b2ofy4Meta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-04-24_15_40/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexEssbAYOBuvB82rAl0vc_45bHF01OHS24VQK71jzr5KZ2wMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-04-24_15_40/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-04-24_15_40/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-04-24_15_40/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-04-24_15_40/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-04-24_15_40/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-04-24_15_40/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importecnImX2BLFxAAQY3Y1F5pB5HzLQrcStrYBfS9kPvD_UMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutSqOz31pw3SRBEDCGzTn7Sr80ceN9l5GH_45SqKtSjtKYQMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-04-24_15_40/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-04-24_15_40/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024_45FR3O7p8HTkbotxzCy4wv61V_45IjlHOijJD3tmsR5YJEMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonbc_45kzl1BBaXXSMnj5qgPhpXlyFAm7p3SfR6L9RzRCIIMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-04-24_15_40/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountCJGQMH_45QF_45AZhzB0D1qQRkDswfLg6_452i_K_zUR_45Vbv8Meta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-04-24_15_40/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-04-24_15_40/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-04-24_15_40/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-04-24_15_40/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorBu0piRNMzGEBRX6hjZpmm8vEsrIZK_EDs8oFMXnbYBkMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-04-24_15_40/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-04-24_15_40/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-04-24_15_40/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountlmSe9kGJ9RTFnwR6YhyA37Sbhf1EcCykJZfHl8pkAwcMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-04-24_15_40/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917fcFJ59xodtMSZLJOvqWwXPoMvNdBY1GdlX07i54ZyRsMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-04-24_15_40/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexrtb8dg34gWzENfB5Frq3RWE8cDyUJ9kHTI5nWCUxprQMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesO_lB5jqrmGnEShex2e11fi8zU4UEmukw9VC6b3XPWccMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93SamMVL8jIJtBBLXnEzr91_Az6Brw_4544ZqpJoq8x2Ad4Meta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: print0RMEb2R7wVZ2Cpe3eYbn6Ba0ZlK0fsURmUjXPolGHKMMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-04-24_15_40/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_935NDC8MliMvsLQWxHxDNhn9Q_WECXnMSuKU48o7P6fUgMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: create_8HGUeDERXFl8UV2vGi2Ir9LG0T9DRNm_45w79_ayNsNMMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-04-24_15_40/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-04-24_15_40/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesHt9wRP05k__zZL3maFyVcRtM1t44ySh5KyhaaHxyXfoMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-04-24_15_40/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-04-24_15_40/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93_45KToGYj2jEs3spwq95ftuv7XN94uHf20xiwhynElQkcMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexW1lly7Y2ZcamWnfGThBE0M7IGybvSCs76Gipz6iQBJsMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45market8LMuIMWbk3btUqbXh_55RD18ACo6zVPrw2WCCNHaVWoMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatessdq0uTcintUX_45sJOopL5nMxDfhTuTnlNulLW0nqR3JYMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexb_c1AZYexoubRX4RYdiVgawQZkMmfbIVmuTKVhY_45r_0Meta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93i_45ZGUgq7rqIUyINNW1Y4CnRDb7c3Z9Gtjgeo0vu34rsMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexpSvk2z9mev3YmGV4cMKAFTaekJ10fXU7kvWRtUVhEvwMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93G5B1biRi3wq20S2ftz44RXw2t_m_45cB4nuadr0xSMR1AMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexkfaIStm9yhRfRTUZXu5EoPkCrqT4OFtTzlbnNIWOOzoMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexroHG1rtCzLeDyu0QIKZRNfkPvmTJXRVXJn4pgMeF1LYMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93Cb6elC98E0lwbQnU5p9eOIU5gNR0uLQi3jB_iwD9fgAMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93Nlwryri53sIzVplHbrooxf1MICMG8BsxKYC2MxJLGFUMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93ZOpDZS0s8We_45PZvyLMUaZ0WjwBrAe4KqfD2IdQGy7JAMeta || {},
    component: () => import("/var/www/2025-04-24_15_40/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-04-24_15_40/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-04-24_15_40/pages/shippingtypes/personalitemstransportation.vue")
  }
]